import { toast } from "react-toastify";
import APIPaths from "../../utils/APIPaths";
import axiosInstance from "../axiosInstance";

export const getPaymentList = async (page, rowsPerPage, data) => {
  try {
    const response = await axiosInstance.get(
      `${APIPaths.GET_PAYMENT_LIST}/${page}/${rowsPerPage}`,
      {
        params: {
          paymentFilterDto: data,
        },
      }
    );

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    console.error("Error fetching payment list:", error);
    toast.error("Error fetching payment list.");
  }
};

export const getClientPaymentList = async (id) => {
  try {
    const URL = APIPaths.GET_PAYMENT_LIST_BY_CLIENT_ID + id;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    } else {
      return [];
    }
  } catch (error) {}
};

export const getInvoiceList = async (page, rowsPerPage, data) => {
  try {
    const response = await axiosInstance.get(
      `${APIPaths.GET_INVOICE_LIST}/${page}/${rowsPerPage}`,
      {
        params: {
          invoiceFilterDto: data,
        },
      }
    );

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    console.error("Error fetching invoice list:", error);
    toast.error("Error fetching invoice list.");
  }
};

export const getInvoiceById = async (id) => {
  try {
    const URL = APIPaths.GET_INVOICE_BY_ID + id;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {
    toast.warning("Something went wrong.");
  }
};

export const AddPaymentService = async (bodyObj) => {
  try {
    const response = await axiosInstance.post(APIPaths.ADD_PAYMENT, bodyObj);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const addInvoiceService = async (bodyObj) => {
  try {
    const response = await axiosInstance.post(APIPaths.CREATE_INVOICE, bodyObj);
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    if (error.response.data.errors) {
    for (const item in error.response.data.errors) {
      toast.error(error.response.data.errors[item]);
    }
    } else {
    toast.error(error.response.data.message);
  }
}
};

export const getBillCodes = async () => {
  try {
    const response = await axiosInstance.get(APIPaths.GET_BILL_CODES);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const AddBillCode = async (bodyObj) => {
  try {
    const response = await axiosInstance.post(APIPaths.ADD_BILL_CODE, bodyObj);
    if (response.status === 200) {
      toast.success("Bill code added successfully");
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const updateBillCode = async (bodyObj) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.UPDATE_BILL_CODE,
      bodyObj
    );
    if (response.status === 200) {
      toast.success("Bill code updated successfully");
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const deleteBillCode = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${APIPaths.DELETE_BILL_CODE}/${id}`
    );
    if (response.status === 200) {
      toast.success("Bill code deleted successfully");
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const downloadInvoicePDFByInvoiceID = async (
  id,
  data,
  servicePackId
) => {
  try {
    const URL = APIPaths.DOWNLOAD_INVOICE_PDF_BY_INVOICE_ID + id;
    const response = await axiosInstance.get(URL, {
      params: {
        layoutDto: data,
      },
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/pdf",
      },
    });
    if (response.status === 200) {
      toast.success("Invoice PDF Downloaded Successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Invoice Not Available");
    }
  } catch (error) {
    toast.error("Invoice PDF Download failed");
  }
};

export const viewInvoicePDFByInvoiceID = async (id, data) => {
  try {
    const URL = APIPaths.DOWNLOAD_INVOICE_PDF_BY_INVOICE_ID + id;
    const response = await axiosInstance.get(URL, {
      params: {
        layoutDto: data,
      },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      const url = window.URL.createObjectURL(response.data);
      return url;
    }
  } catch (error) {
    toast.error("View document failed");
  }
};

export const deletePaymentByIdAPIHandler = async (id) => {
  try {
    const URL = APIPaths.DELETE_PAYMENT_BY_ID + id;
    const response = await axiosInstance.delete(URL);

    if (response.status === 200) {
      toast.success("Payment details deleted successfully.");
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const downloadPaymentReceiptPDFByPaymentID = async (id, data) => {
  try {
    const URL = APIPaths.DOWNLOAD_PAYMENT_RECEIPT_PDF_BY_PAYMENT_ID + id;
    const response = await axiosInstance.get(URL, {
      params: {
        layoutDto: data,
      },
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/pdf",
      },
    });
    if (response.status === 200) {
      toast.success("Payment Receipt Downloaded Successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Payment Not Available");
    }
  } catch (error) {
    toast.error(error.message);
  }
};

export const viewPaymentReceiptPDFByPaymentID = async (id, data) => {
  try {
    const URL = APIPaths.DOWNLOAD_PAYMENT_RECEIPT_PDF_BY_PAYMENT_ID + id;
    const response = await axiosInstance.get(URL, {
      params: {
        layoutDto: data,
      },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      const url = window.URL.createObjectURL(response.data);
      return url;
    }
  } catch (error) {
    toast.error("View document failed");
  }
};

export const getPreDefinedPackages = async (page, rowsPerPage, searchData) => {
  try {
    const response = await axiosInstance.get(
      `${APIPaths.GET_ALL_PREDEFINED_SERVICE_PACKS}/${page}/${rowsPerPage}`,
      {
        params: {
          text: searchData,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

/**
 * This function adds the defined package for the particular organization.
 * @param {*} bodyObj
 * @returns
 */
export const addPackage = async (bodyObj) => {
  try {
    const response = await axiosInstance.post(APIPaths.ADD_PACKAGE, bodyObj);
    if (response.status === 201) {
      toast.success("Package added successfully.");
      return response;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
    console.error(error);
  }
};

/**
 * This function updates the package of particular organization.
 * @param {*} bodyObj
 * @returns
 */
export const updatePackage = async (bodyObj) => {
  try {
    const response = await axiosInstance.post(APIPaths.UPDATE_PACKAGE, bodyObj);
    if (response.status === 200) {
      toast.success("Package updated successfully");
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
    console.error(error);
  }
};

/**
 * This function deletes the package by package id of particular organization.
 * @param {*} id
 * @returns
 */
export const deletePackage = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${APIPaths.DELETE_PACKAGE}/${id}`
    );
    if (response.status === 200) {
      toast.success("Package deleted successfully");
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
    console.error(error);
  }
};

export const getAllPackage = async (appointmentId) => {
  try {
    const response = await axiosInstance.get(
      `${APIPaths.GET_ALL_PACKAGE}/${appointmentId}`
    );
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const deleteInvoiceByInvoiceId = async (id) => {
  try {
    const URL = APIPaths.DELETE_INVOICE_BY_ID + id;
    const response = await axiosInstance.delete(URL);

    if (response.status === 200) {
      toast.success("Invoice details deleted successfully.");
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const getClientAvailableBalance = async (clientId) => {
  try {
    const response = await axiosInstance.get(
      `${APIPaths.GET_CLIENT_AVAILABLE_BALANCE}/${clientId}`
    );
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const downloadPaymentFile = async (data) => {
  try {
    const URL = APIPaths.DOWNLOAD_PAYMENT_FILE;
    const response = await axiosInstance.get(URL, {
      params: {
        generateCsvOrPdf: data,
      },
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      toast.success("File downloaded successfully");
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        return url;
      }
    } else if (response.status === 204) {
      toast.warning(
        "No data found for selected date range. Please adjust date range or other selection criteria."
      );
    }
  } catch (error) {
    try {
      const decodedString = new TextDecoder().decode(error.response.data);
      const parsedError = JSON.parse(decodedString);

      if (parsedError?.message) {
        toast.error(parsedError.message);
      } else {
        toast.error("File download failed");
      }
    } catch (decodeError) {
      toast.error("File download failed due to unexpected error");
      console.error("Decode error:", decodeError);
    }
    console.error("Axios error:", error.response);
  }
};

export const downloadInvoiceFile = async (data) => {
  try {
    const URL = APIPaths.DOWNLOAD_INVOICE_FILE;
    const response = await axiosInstance.get(URL, {
      params: {
        generateCsvOrPdf: data,
      },
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      toast.success("File downloaded successfully");
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        return url;
      }
    } else if (response.status === 204) {
      toast.warning(
        "No data found for selected date range. Please adjust date range or other selection criteria."
      );
    }
  } catch (error) {
    try {
      const decodedString = new TextDecoder().decode(error.response.data);
      const parsedError = JSON.parse(decodedString);

      if (parsedError?.message) {
        toast.error(parsedError.message);
      } else {
        toast.error("File download failed");
      }
    } catch (decodeError) {
      toast.error("File download failed due to unexpected error");
      console.error("Decode error:", decodeError);
    }
    console.error("Axios error:", error.response);
  }
};

export const downloadInvoiceReport = async (data) => {
  try {
    const URL = APIPaths.DOWNLOAD_INVOICE_REPORT;
    const response = await axiosInstance.post(URL, data, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      toast.success("File downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning(
        "No data found for selected date range. Please adjust date range or other selection criteria."
      );
    }
  } catch (error) {
    try {
      const decodedString = new TextDecoder().decode(error.response.data);
      const parsedError = JSON.parse(decodedString);

      if (parsedError?.message) {
        toast.error(parsedError.message);
      } else {
        toast.error("File download failed");
      }
    } catch (decodeError) {
      toast.error("File download failed due to unexpected error");
      console.error("Decode error:", decodeError);
    }
    console.error("Axios error:", error.response);
  }
};

export const downloadPaymentReport = async (data) => {
  try {
    const URL = APIPaths.DOWNLOAD_PAYMENT_REPORT;
    const response = await axiosInstance.post(URL, data, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    if (response.status === 200) {
      toast.success("File downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning(
        "No data found for selected date range. Please adjust date range or other selection criteria."
      );
    }
  } catch (error) {
    try {
      const decodedString = new TextDecoder().decode(error.response.data);
      const parsedError = JSON.parse(decodedString);

      if (parsedError?.message) {
        toast.error(parsedError.message);
      } else {
        toast.error("File download failed");
      }
    } catch (decodeError) {
      toast.error("File download failed due to unexpected error");
      console.error("Decode error:", decodeError);
    }
    console.error("Axios error:", error.response);
  }
};

export const updateInvoiceService = async (bodyObj) => {
  try {
    const URL = APIPaths.UPDATE_INVOICE;
    const response = await axiosInstance.post(URL, bodyObj);

    if (response.status === 200) {
      return response.data;
    }
  }catch (error) {
  if (error?.response?.data) {
    if (typeof error.response.data === 'string') {
      toast.error(error.response.data);
    } else if (error.response.data.errors) {
      const errors = error.response.data.errors;
      if (Array.isArray(errors)) {
        errors.forEach(err => toast.error(err));
      } else {
        for (const key in errors) {
          toast.error(errors[key]);
        }
      }
    } else {
      toast.error(error.response.data.message || 'Something went wrong');
    }
  } else {
    toast.error('Something went wrong');
  }
}
};

export const updateServicePackService = async (
  servicePackId,
  extendedValidity,
  servicePackConsumeCount, purchaseDate
) => {
  try {
    const extendedValidityValue =
      extendedValidity === undefined ? 0 : extendedValidity;
    const consumeCount =
      servicePackConsumeCount === undefined ? 0 : servicePackConsumeCount;

    const URL = `${APIPaths.UPDATE_SERVICE_PACK}/${servicePackId}/${extendedValidityValue}/${consumeCount}/${purchaseDate}`;
    const response = await axiosInstance.post(URL);

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const getTotalInvoices = async (data) => {
  try {
    const URL = `${APIPaths.GET_INVOICE_GRAPH_DETAILS}`;
    const response = await axiosInstance.post(URL, data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    toast.error(error.response.data.message);
  }
};

export const getTotalPayments = async (data) => {
  try {
    const URL = `${APIPaths.GET_PAYMENT_GRAPH_DETAILS}`;
    const response = await axiosInstance.post(URL, data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    toast.error(error.response.data.message);
  }
};

export const downloadInvoiceAndPaymentReportCSV = async (data) => {
  try {
    const URL = APIPaths.GENERATE_CSV_FOR_INVOICE_AND_PAYMENT_GRAPH;
    const response = await axiosInstance.post(URL, JSON.stringify(data), {
      responseType: "arraybuffer",
    });
    if (response.status === 200) {
      toast.success("File downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    }
  } catch (error) {
    console.error("Error downloading CSV : ", error);
  }
};

export const addRefund = async (bodyObj) => {
  try {
    const response = await axiosInstance.post(APIPaths.ADD_REFUND, bodyObj);
    if (response.status === 200) {
      toast.success(response.message);
      return response;
    }
  } catch (error) {
    if (error.response.data) {
      toast.error(error.response.data.message);
    }
  }
};

export const updateRefund = async (bodyObj) => {
  try {
    const response = await axiosInstance.put(APIPaths.UPDATE_REFUND, bodyObj);
    if (response.status === 200) {
      toast.success(response.message);
      return response;
    }
  } catch (error) {
    if (error.response.data) {
      toast.error(error.response.data.message);
    }
  }
};

export const getRefundList = async (page, rowsPerPage, data) => {
  try {
    const URL = `${APIPaths.GET_ALL_REFUNDS}/${page}/${rowsPerPage}`;
    const response = await axiosInstance.get(URL, {
      params: {
        refundFilterDto: data,
      },
    });

    if (response.status === 200) {
      return response;
    }

    return [];
  } catch (error) {}
};

export const deleteRefund = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${APIPaths.DELETE_REFUND}/${id}`
    );
    if (response.status === 200) {
      toast.success(response.message);
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const getInvoiceListByClientId = async (
  page,
  rowsPerPage,
  clientId,
  data
) => {
  try {
    const response = await axiosInstance.get(
      `${APIPaths.GET_ALL_INVOICES_BY_CLIENT}/${page}/${rowsPerPage}/${clientId}`,
      {
        params: {
          invoiceFilterDto: data,
        },
      }
    );

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    console.error("Error fetching invoice list:", error);
    toast.error("Error fetching invoice list.");
  }
};

export const getClientRefundList = async (clientId) => {
  try {
    const response = await axiosInstance.get(
      `${APIPaths.GET_REFUNDS_BY_CLIENT_ID}/${clientId}`
    );
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const downloadRefundReport = async (data) => {
  try {
    const URL = APIPaths.GENERATE_CSV_OR_PDF_FOR_REFUND_REPORT;
    const response = await axiosInstance.post(URL, data, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      toast.success("File downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning(
        "No data found for selected date range. Please adjust date range or other selection criteria."
      );
    }
  } catch (error) {
    try {
      const decodedString = new TextDecoder().decode(error.response.data);
      const parsedError = JSON.parse(decodedString);

      toast.error(parsedError?.message || "File download failed");
    } catch (decodeError) {
      toast.error("File download failed due to unexpected error");
      console.error("Decode error:", decodeError);
    }
    console.error("Axios error:", error.response);
  }
};

export const getTotalRefunds = async (data) => {
  try {
    const URL = `${APIPaths.GET_REFUND_GRAPH_DETAILS}`;
    const response = await axiosInstance.post(URL, data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    toast.error(error.response.data.message);
  }
};

export const downloadRefundReportCSV = async (data) => {
  try {
    const URL = APIPaths.GENERATE_CSV_FOR_REFUND_GRAPH;
    const response = await axiosInstance.post(URL, JSON.stringify(data), {
      responseType: "arraybuffer",
    });
    if (response.status === 200) {
      toast.success("File downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    }
  } catch (error) {
    console.error("Error downloading CSV : ", error);
  }
};

export const downloadRefundReceiptPDFByRefundID = async (id, data) => {
  try {
    const URL = APIPaths.DOWNLOAD_REFUND_RECEIPT_PDF_BY_REFUND_ID + id;
    const response = await axiosInstance.get(URL, {
      params: {
        layoutDto: data,
      },
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/pdf",
      },
    });
    if (response.status === 200) {
      toast.success("Refund Receipt Downloaded Successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Refund Not Available");
    }
  } catch (error) {
    toast.error(error.message);
  }
};

export const viewRefundReceiptPDFByRefundID = async (id, data) => {
  try {
    const URL = APIPaths.DOWNLOAD_REFUND_RECEIPT_PDF_BY_REFUND_ID + id;
    const response = await axiosInstance.get(URL, {
      params: {
        layoutDto: data,
      },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      const url = window.URL.createObjectURL(response.data);
      return url;
    }
  } catch (error) {
    toast.error("View document failed");
  }
};
